export default "__VITE_ASSET__9a0d6e61__"